/*
 * Palo Alto Theme — custom.js
 * Loaded after theme.dev.js (layout/theme.liquid). Vanilla JS, no jQuery.
 */

// ------------ Discount-Code–Funktionalität ------------
// (reserved)
// ------------------------------------------------------

/* iOS-only: maximum-scale=1 unterbindet das Auto-Zoomen beim Fokus auf
 * Eingabefelder. Pinch-Zoom des Nutzers bleibt möglich (WebKit ignoriert
 * maximum-scale seit iOS 10 für Nutzer-Gesten). Auf Android NICHT setzen —
 * dort würde es den Pinch-Zoom tatsächlich sperren. */
(function () {
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isIOS) { return; }
  var meta = document.querySelector('meta[name="viewport"]');
  if (meta && meta.content.indexOf('maximum-scale') === -1) {
    meta.content += ', maximum-scale=1.0';
  }
})();

/* ============================================================
 * Stadtkinder Navigation (Konzept 06/2026, Mobile-Akkordeon 08/2026)
 * - Desktop: open/close mega panels (hover + click + ESC + outside)
 * - Mobile : accordion sections inside the theme drawer (#nav-drawer)
 *   The drawer open/close itself is handled by the theme.
 * ============================================================ */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 1008px)';
  function isDesktop() { return window.matchMedia(DESKTOP).matches; }

  /* ---------------- Desktop mega panels ---------------- */
  function closePanels(nav) {
    nav.querySelectorAll('[data-sk-panel]').forEach(function (p) { p.hidden = true; });
    nav.querySelectorAll('[data-sk-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  function openPanel(nav, key) {
    closePanels(nav);
    var panel = nav.querySelector('[data-sk-panel="' + key + '"]');
    var btn = nav.querySelector('[data-sk-toggle="' + key + '"]');
    if (panel) { panel.hidden = false; }
    if (btn) { btn.setAttribute('aria-expanded', 'true'); }
  }

  function initDesktop(nav) {
    if (nav.__skInit) { return; }
    nav.__skInit = true;

    /* Zwischen Menüzeile (Ende ~y72) und Panel (beginnt an der Header-Unterkante)
       liegt ein schmaler Streifen, der nicht zur .sk-nav gehört — eine echte
       Mausbewegung Richtung Panel löst dort mouseleave aus und das Panel wäre zu,
       bevor man es erreicht. Daher: verzögert schließen, Wiedereintritt bricht ab. */
    var closeTimer = null;
    function cancelClose() {
      if (closeTimer) { window.clearTimeout(closeTimer); closeTimer = null; }
    }
    function scheduleClose() {
      cancelClose();
      closeTimer = window.setTimeout(function () { closePanels(nav); }, 250);
    }

    nav.querySelectorAll('.sk-nav__item').forEach(function (li) {
      var btn = li.querySelector('[data-sk-toggle]');
      if (btn) {
        var key = btn.getAttribute('data-sk-toggle');
        li.addEventListener('mouseenter', function () { if (isDesktop()) { cancelClose(); openPanel(nav, key); } });
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var open = btn.getAttribute('aria-expanded') === 'true';
          if (open) { closePanels(nav); } else { openPanel(nav, key); }
        });
      } else {
        // hovering a plain link closes any open panel (innerhalb der Bar: sofort)
        li.addEventListener('mouseenter', function () { if (isDesktop()) { cancelClose(); closePanels(nav); } });
      }
    });

    // leaving the whole nav (bar + panels are children) closes everything — verzögert
    nav.addEventListener('mouseenter', cancelClose);
    nav.addEventListener('mouseleave', function () { scheduleClose(); });
  }

  /* Das Theme setzt 'hide-header' direkt nach dem Seitenwechsel (Scroll-Up-Erkennung
     feuert beim Load, obwohl scrollY=0). Am Seitenanfang gibt es nichts zu verstecken —
     Zustand dort konsequent aufräumen, sonst startet der Header im Geist-Modus. */
  function unhideHeaderAtTop() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (y <= 1) { document.body.classList.remove('hide-header'); }
  }
  window.addEventListener('load', unhideHeaderAtTop);
  window.addEventListener('pageshow', unhideHeaderAtTop);
  document.addEventListener('theme:scroll', function () {
    window.requestAnimationFrame(unhideHeaderAtTop);
  });

  /* ---------------- Mobile accordion ---------------- */
  function resetDrawer() {
    document.querySelectorAll('[data-sk-acc].is-open').forEach(function (s) {
      s.classList.remove('is-open');
      var b = s.querySelector('[data-sk-acc-toggle]');
      if (b) { b.setAttribute('aria-expanded', 'false'); }
    });
  }

  document.addEventListener('click', function (e) {
    // toggle an accordion section
    var accBtn = e.target.closest('[data-sk-acc-toggle]');
    if (accBtn) {
      e.preventDefault();
      var sec = accBtn.closest('[data-sk-acc]');
      if (sec) {
        var open = sec.classList.toggle('is-open');
        accBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    // focus the search field from the bottom bar
    var sf = e.target.closest('[data-sk-search-focus]');
    if (sf) {
      e.preventDefault();
      var d = sf.closest('[data-sk-drawer]');
      var inp = d && d.querySelector('.sk-d__search-input');
      if (inp) { inp.focus(); }
      return;
    }

    // desktop: click outside the nav closes panels
    if (!e.target.closest('[data-sk-nav]')) {
      document.querySelectorAll('[data-sk-nav]').forEach(closePanels);
    }

    // reset accordion sections whenever the drawer is toggled (open or close) or overlay tapped
    if (e.target.closest('[data-drawer-toggle][aria-controls="nav-drawer"]') ||
        e.target.closest('.drawer__overlay')) {
      window.setTimeout(resetDrawer, 50);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      document.querySelectorAll('[data-sk-nav]').forEach(closePanels);
      resetDrawer(); // theme closes the drawer on ESC too — collapse sections with it
    }
  });

  /* ---------------- Init ---------------- */
  function initAll() {
    document.querySelectorAll('[data-sk-nav]').forEach(initDesktop);
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', initAll);
})();
